module.exports = __webpack_public_path__ + "img/user-winner.b8ae4a1c.svg";